import React, {useContext} from 'react';
import { LocaleContext } from '../common/App';
import { Footer } from './WebsiteCommon';
import { SuspenseComp } from './Imprint';
import PrivacyPolicyDe from './de/PrivacyPolicyDe';

import StatisticCookieInfoDe from './de/StatisticCookieInfoDe';
import StatisticCookieInfoEn from './en/StatisticCookieInfoEn';

export function StatisticCookieInfo(props) {
    const locale = useContext(LocaleContext);

    return (
        <div>
            <div className="flex_col">
                {
                    locale.locale === "de" ?
                        <React.Suspense fallback={<SuspenseComp />}>
                            <StatisticCookieInfoDe />
                        </React.Suspense>
                    : locale.locale === "en" ?
                        <React.Suspense fallback={<SuspenseComp />}>
                            <StatisticCookieInfoEn />
                        </React.Suspense>
                    :
                        null
                }
            </div>
        </div>
    );
}
